import React, { createContext, useContext } from "react";
import { currentAppPath } from "../auth/loginRedirect";
import { requestAskWittyAuth } from "../auth/askWittyAuthIntent";

export const LoginContext = createContext();

export function useLoginContext() {
  return useContext(LoginContext);
}

export function LoginProvider({ children }) {
  const [openLogin, setOpenLogin] = React.useState(false);

  // Ask Witty is the primary login surface; the legacy modal only opens where
  // the sidecar is not mounted.
  const handleOpenLogin = () => {
    if (requestAskWittyAuth({ returnTo: currentAppPath(), reason: "login_modal" })) return;
    setOpenLogin(true);
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  return (
    <LoginContext.Provider
      value={{ openLogin, handleOpenLogin, handleCloseLogin }}
    >
      {children}
    </LoginContext.Provider>
  );
}
